import React from "react";
import okLogo from "../../../assets/images/ok-logo.png";
import colorImg from "../../../assets/images/colour.png";
import Nathicharami from "../../../assets/images/Nathicharami.png";
import NathicharamiLogo from "../../../assets/images/Nathicharami_Logo.jpg";
import "./Header.css";

export function Header(){
    return(
           <div className="main-header container">
      <div className="header-left-part">
        <img src={colorImg} alt="logo" />
        {/* <div className="header-left-text">
          <p>Arihant Raaj</p>
          <p>Vastu Astro Numero Expert</p>
        </div> */}
      </div>
      <div className="header-right-part">
        <img src={NathicharamiLogo} alt="Nathicharami" />
      </div>
    </div>
    )
}